module.exports = __webpack_public_path__ + "static/opensans-light-webfont-7a7ee47c969a72e9eda5e5a9af03509c.woff";